(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sacovo-draft"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle', function(event) {
  const menu = event.target;
  if (!(menu instanceof HTMLDetailsElement) || !menu.matches('[data-sacovo-nav]') || !menu.open) return;
  document.querySelectorAll('[data-sacovo-nav]').forEach(function(other) { if (other !== menu) other.open = false; });
}, true);
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('[data-sacovo-nav][open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-sacovo-nav] a');
  if (link) {
    document.querySelectorAll('[data-sacovo-nav]').forEach(function(menu) { menu.open = false; });
    const destination = document.querySelector(link.getAttribute('href'));
    if (destination) destination.focus({ preventScroll: true });
  } else if (!event.target.closest('[data-sacovo-nav]')) {
    document.querySelectorAll('[data-sacovo-nav]').forEach(function(menu) { menu.open = false; });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sacovo-film-hero"] && !Shopify.designMode) return;
  try {
    
  class SacovoFilm extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const video = this.querySelector('video');
      const poster = this.querySelector('.sacovo-film__poster');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let started = false;
      let visible = true;
      const play = () => {
        if (!started || !visible || document.hidden || motion.matches) return;
        video.play().catch(() => {});
      };
      const start = () => {
        if (started || !this.isConnected || motion.matches) return;
        started = true;
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
        });
        video.load();
        play();
      };
      const afterPoster = () => requestAnimationFrame(() => requestAnimationFrame(start));
      video.addEventListener('playing', () => this.classList.add('is-playing'), { signal });
      video.addEventListener('error', () => this.classList.remove('is-playing'), { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else play();
      }, { signal });
      motion.addEventListener('change', () => {
        if (motion.matches) {
          video.pause();
          this.classList.remove('is-playing');
        } else if (!started) afterPoster();
        else play();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) play();
        else video.pause();
      });
      this.observer.observe(this);
      if (poster.complete) afterPoster();
      else {
        poster.addEventListener('load', afterPoster, { once: true, signal });
        poster.addEventListener('error', afterPoster, { once: true, signal });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
      this.controller = null;
    }
  }
  if (!customElements.get('sacovo-film')) customElements.define('sacovo-film', SacovoFilm);

  } catch(e) { console.error(e); }
})();
})();
